import { APP_PREFIX_PATH } from '@constants/common';
import { Link as MUILink, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

const LoginFooter = () => {
    return (
        <div className="flex flex-col w-full text-center items-center">
            <div className="flex flex-row mb-4 w-full items-center">
                <div className="flex-1 border-t border-light-gray"></div>
                <Typography className="font-museo px-6" variant="body1" fontWeight={700}>
                    <FormattedMessage
                        id="auth.login.footer.noAccount"
                        defaultMessage="No account yet?"
                        description="Text asking if user has an account yet. Used in: /auth/login"
                    />
                </Typography>
                <div className="flex-1 border-t border-light-gray"></div>
            </div>
            <Typography className="text-sm text-gray-600 mb-2">
                <FormattedMessage
                    id="auth.login.footer.signUpMessage"
                    defaultMessage="{signUpLink} today and get access to events, online training, and stay updated about the latest developments with regular updated video's and news articles"
                    description="Message encouraging users to sign up with benefits. Used in: /auth/login"
                    values={{
                        signUpLink: (
                            <MUILink
                                component={Link}
                                to={{ pathname: APP_PREFIX_PATH + '/auth/sign-up', search: window.location.search }}
                                className="text-primary-600 hover:text-primary-600 font-bold cursor-pointer"
                            >
                                <FormattedMessage
                                    id="auth.common.signUp"
                                    defaultMessage="Sign up"
                                    description="Link text for sign up"
                                />
                            </MUILink>
                        ),
                    }}
                />
            </Typography>
        </div>
    );
};

export { LoginFooter };
